module.exports = __webpack_public_path__ + "static/media/Longline_logo_web.0e5aa626.svg";